import { toast } from "react-toastify";
import { notifySuccess } from "src/assets/toastService";
import { buildInvoiceHtml } from "../../home/Done/hooks/invoiceTemplate";
import { generatePdf } from "../../home/Done/hooks/pdfUtils";
import api from "src/features/auth/axiosConfig";

export const SendMail = { Blue: "blue", name: "Send Mail" };
export const SendMessage = { Blue: "blue", name: "Send Message" };
export const COMPLETE = { Blue: "blue", name: "COMPLETE" };
export const CANCEL = { Cancel: "red", name: "CANCEL" };
export const Update = { Blue: "blue", name: "update" };
export const YESCANCEL = { Blue: "blue", name: "Confirm" };
export const Cancel = { Cancel: "red", name: "Cancel" };

export const date = (setTime: (time: { hours: string; minutes: string; seconds: string; day: string; month: string; year: string }) => void) => {
  const currentDate = new Date();
  const year = String(currentDate.getFullYear());
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  setTime({ hours: hours, minutes: minutes, seconds: seconds, day: day, month: month, year: year });
};
export const orderback = (orderid: string) => {
  window.location.href = `/pos/v1/order-details/${orderid}`;
};
export const Doneorder = (setConfirm?: (val: boolean) => void, getOrdersIn?: () => void) => {
  notifySuccess("The order has been taken successfully");

  setTimeout(() => {
    if (setConfirm) {
      setConfirm(false);
    }
    if (getOrdersIn) {
      getOrdersIn();
    }
  }, 1000);
};
export const formatNumber = (num: number): string => {
  return num.toFixed(2);
};
export const formatNumbers = (num: any): string => {
  const parsed = Number(num);
  if (isNaN(parsed)) return "NaN";
  return parsed.toFixed(2);
};
export const OrderUpdate = ({
  getorder,
  condition,
  inputValue,
  outstangingamount,
  time,
  Payment,
}: {
  getorder: any;
  condition: number;
  inputValue: number;
  outstangingamount: number;
  time: { year: string; month: string; day: string; hours: string; minutes: string; seconds:string; };
  Payment: string;
}) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const TOTALAMOUNT = Number(getorder?.Finalamount);
  const RESAMOUNT = Number(getorder?.payments[0]?.ReceivedAmount || 0) + condition;
  let ReceivedAmount = 0;
  let RemainingAmount = 0;
  if (TOTALAMOUNT >= RESAMOUNT) {
    ReceivedAmount = condition;
    RemainingAmount = TOTALAMOUNT - RESAMOUNT;
  } else {
    ReceivedAmount = Number(getorder?.RemainingAmount);
    RemainingAmount = 0;
  }
  return {
    Finalamount: TOTALAMOUNT,
    RemainingAmount: RemainingAmount,
    OrderStatus: "Delivered",
    DeliveryDate: `${year}-${month}-${day}`,
    DeliveryTime: `${hours}:${minutes}:${seconds}`,
    payments: [{ Paymentmethod: Payment, ReceivedAmount: inputValue }],
    paymentHistory: [...(getorder?.payments || []), { Paymentmethod: Payment, ReceivedAmount: ReceivedAmount }],
    id: getorder?.Customerid,
    outstanding_balance: outstangingamount,
    new_order_amount: 0,
    Orderdate: `${time.year}-${time.month}-${time.day}`,
    Ordertime: `${time.hours}:${time.minutes}:${time.seconds}`,
  };
};

export const orderemailmsg = async (
  getorder: any,
  email: string,
  ResAmount: string,
  id: string,
  Tamount: number,
  Ramount: string,
  handleDone: () => void
) => {
  const toastId3 = toast.loading("Waiting...", { position: "top-right", autoClose: 2000, theme: "colored" });
  const htmlContent = buildInvoiceHtml({
    CustomerName: getorder.CustomerName || "Valued Customer",
    Orderdate: getorder.Orderdate,
    Products: getorder.Products,
    totalAmount: getorder.totalAmount,
  });
  const pdfBlob = await generatePdf(htmlContent);
  try {
    const formData = new FormData();
    formData.append("file", pdfBlob, "Invoice.pdf");
    formData.append("receiver_email", email);
    formData.append("cnames", getorder.CustomerName || "Valued Customer");
    formData.append("id", getorder.Orderid);
    formData.append("TotalAmount", String(getorder.totalAmount ?? 0));
    formData.append("ReceivedAmount", String(getorder.payments?.[0]?.ReceivedAmount ?? 0));
    formData.append("RemainingAmount", String(getorder.RemainingAmount ?? 0));

    await api.post(`/app/v1/pos/orders_send_email`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    toast.dismiss(toastId3);
    toast.success("Mail sent successfully", { autoClose: 2000 });
    handleDone();
  } catch (err) {
    toast.dismiss(toastId3);
    toast.error("Failed to send email", { autoClose: 2000 });
    console.error(err);
  }
};
